import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'smartDate'
})
export class SmartDatePipe implements PipeTransform {

  // Inyección clásica por constructor para entornos no-standalone
  constructor(private datePipe: DatePipe) {}

  transform(value: any, locale: string = 'es-ES'): string | null {
    if (!value) return '';

    let fechaEntrada: Date;

    if (typeof value === 'string' && value.length <= 10) {
      const fechaNormalizada = value.replace(/-/g, '/');
      fechaEntrada = new Date(fechaNormalizada);
    } else {
      fechaEntrada = new Date(value);
    }

    if (isNaN(fechaEntrada.getTime())) return '';

    const anioActual = new Date().getFullYear();
    const anioEntrada = fechaEntrada.getFullYear();

    if (anioEntrada === anioActual) {
      return this.datePipe.transform(fechaEntrada, "EEEE, d 'de' MMMM", undefined, locale);
    } else {
      return this.datePipe.transform(fechaEntrada, "EEEE, d 'de' MMMM 'de' yyyy", undefined, locale);
    }
  }
}